// extracted by mini-css-extract-plugin
module.exports = {"root":"YoutubePlayer_root__2cBIb"};